module.exports = __webpack_public_path__ + "static/img/far3_active.349b1d08.jpg";